import React, { useEffect, useRef } from 'react';
import { useState } from 'react';
import { Link, NavLink, useNavigate } from "react-router"
import { generatePlaceholderArrays } from '../utils';
import { useInfo } from '../context/useInfo';

interface LinkArgs {
    children?: React.JSX.Element | string,
    image?: string,
    to: string,
    className?: string
    onClick?: () => void
}

export default function () {
    const { fetchWeb } = useInfo();
    const navigate = useNavigate();

    // const [headerOpen, setHeaderOpen] = useState(false);
    const [searchValue, setSearchValue] = useState("");
    const [searchArticles, setSearchArticles] = useState<Record<string, any>[] | null>(null);

    function HeaderLink({ children, image, to: target }: LinkArgs) {
        return <NavLink
            className={({ isActive }) => (
                'sm:py-2 phones:-top-8 phones:relative phones:origin-bottom phones:transition-transform ' +
                (isActive ?
                    (
                        'sm:mx-3 sm:px-4 sm:bg-foreground sm:rounded-t-xl ' +
                        'sm:relative sm:before:w-3 sm:after:w-3 sm:before:absolute sm:after:absolute sm:before:top-0 sm:after:top-0 ' +
                        'sm:before:rounded-br-xl sm:after:rounded-bl-xl sm:before:bg-background sm:after:bg-background ' +
                        'sm:before:h-full sm:after:h-full sm:before:-left-3 sm:after:-right-3 ' +

                        'phones:[&_img]:w-16 phones:scale-150'
                    ) :
                    (
                        'sm:px-5 sm:bg-background ' +

                        'phones:[&_img]:w-16 phones:hover:scale-110'
                    )
                )
            )}
            to={target}
        >
            <span className='inline-block phones:hidden'>{children}</span>
            <img className="inline sm:hidden" src={image} alt="image" />
        </NavLink>
    }

    async function getArticleSearch() {
        if (searchValue == "") return;
        const response = await fetchWeb(`/wiki/articles?search=${searchValue}`)
        if (response) {
            setSearchArticles(response)
        }
    }

    useEffect(() => {
        const timeoutID = setTimeout(() => {
            getArticleSearch()
        }, 700)

        return () => {
            clearTimeout(timeoutID)
        }
    }, [searchValue])

    return <>
        <div className={
            'overflow-hidden bg-foreground rounded-t-xl border-b-[2px] border-b-primary flex text-lg mt-4 ' +
            'sm:hidden'
        }>
            <input
                className={
                    'outline-none flex-grow py-1 px-3 '
                }
                type="text"
                placeholder='Search..'
                value={searchValue}
                onChange={({ target }) => setSearchValue(target.value)}
                onKeyDown={({ code }) => code == "Enter" ? navigate(`/search?q=${searchValue}`) : null}
            />
            <Link
                className='bg-primary py-1 px-2 text-white'
                children='Search'
                to={`/search?q=${searchValue}`}
            />
        </div>
        <header className={
            'max-w-4xl m-auto fixed sm:relative bottom-0 sm:flex sm:mt-8 z-30 phones:h-14 phones:left-2 phones:right-2 ' +
            'phones:rounded-t-full phones:max-w-96 phones:bg-primaryGradient'
        }>
            <img
                className='h-full max-h-[100px] cursor-pointer pb-4 pl-4 hidden sm:block'
                draggable={false}
                src={"/favicon.ico"}
                alt="logo"
                onClick={() => { navigate('/') }}
            />
            <div className="w-full flex flex-col">
                <div className='sm:h-full items-center ml-4 hidden sm:flex'>
                    <h1 className='text-3xl font-semibold'>Andec wiki</h1>
                </div>
                <div className={
                    'grid items-end sm:before:col-[1] sm:before:row-[1] sm:before:bg-foreground sm:before:w-1/2 sm:before:h-1/2 ' +
                    'phones:h-full '
                }>
                    <nav className={
                        'h-full col-[1] row-[1] flex sm:items-end ' +

                        'phones:justify-evenly phones:pt-4'
                    }>
                        <HeaderLink image="/images/simple_home.png" to={"/"}>Home</HeaderLink>
                        <HeaderLink image="/images/bookmarked_icon.png" to={"/bookmarks"}>Bookmarked</HeaderLink>
                        <HeaderLink image="/images/account.png" to={"/dashboard"}>Dashboard</HeaderLink>
                        <div className='hidden sm:block sm:bg-background flex-grow sm:h-1/2' />
                        <div className={
                            "sm:relative sm:block hidden"
                        } >
                            <input
                                className={
                                    'bg-foreground mr-4 sm:mb-1 py-1 px-3 rounded-t-xl border-b-[2px] border-b-primary outline-none ' +
                                    'phones:hidden sm:relative sm:z-10'
                                }
                                type="text"
                                placeholder='Search..'
                                value={searchValue}
                                onChange={({ target }) => setSearchValue(target.value)}
                                onKeyDown={({ code }) => code == "Enter" ? navigate(`/search?q=${searchValue}`) : null}
                            />
                            {searchArticles && <>
                                <div 
                                    className='hidden sm:block sm:fixed top-0 bottom-0 left-0 right-0'
                                    onClick={(e) => setSearchArticles(null)}
                                />
                                
                                <div className={
                                    "top-[calc(100%_-_0.25rem)] absolute bg-foreground w-[calc(100%_-_1rem)] " +
                                    "border-l-2 border-b-2 border-r-2 border-outline"
                                }>
                                    {searchArticles.slice(0, 5).map(article => (
                                        <Link
                                            to={`/${article.article_path}`}
                                            key={article.article_id}
                                            className='block p-2 hover:bg-outline'
                                        >
                                            <span className='block text-primary text-xs'>{`/${article.article_path}`}</span>
                                            <span>{article.title}</span>
                                        </Link>
                                    ))}
                                </div>
                            </>}
                        </div>
                    </nav>
                </div>
            </div>
        </header>
    </>
}